/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var jove__app__quote_document__model__SortByColumnEnum;

(function (jove__app__quote_document__model__SortByColumnEnum) {
  jove__app__quote_document__model__SortByColumnEnum["CREATED_AT"] = "created_at";
  jove__app__quote_document__model__SortByColumnEnum["QUOTE_ID"] = "quote_id";
})(jove__app__quote_document__model__SortByColumnEnum || (jove__app__quote_document__model__SortByColumnEnum = {}));